export default "/_next/static/chunks/fonts/Roboto-LightItalic-latin-6d67bc1e9e2ceb27ddcc2823cc3977f9.woff2";